export default __webpack_public_path__ + "static/media/add-favourite.d234c582.svg";